module.exports = __webpack_public_path__ + "img/equipment_20pt_checked.a21e8378.svg";